<div class="card-body p-0">
    <div class="mat-elevation-z4">
        <div class="w-100 scroll">
            <table mat-table [dataSource]="dataSource" [hidden]="semDados" class="mat-elevation-z1 w-100 " matSort
                matSortDisableClear #tabela1="matSort">
                <!-- Position Column -->
                <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                    <td mat-cell *matCellDef="let element">{{ element?.nome }}</td>
                </ng-container>
                <ng-container matColumnDef="amostra">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Amostra</th>
                    <td mat-cell style="max-width: 200px;" *matCellDef="let element">{{ element?.amostra }}</td>
                </ng-container>
                <!-- Sigla Column -->
                <ng-container matColumnDef="ug">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>UG - Sigla</th>
                    <td mat-cell style="max-width: 200px;" *matCellDef="let element">
                        <span class="badge badge-secondary ml-1"> {{ element?.ug }} </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="questoes">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Questões</th>
                    <td mat-cell style="max-width: 200px;" *matCellDef="let element"> {{ element?.questoes }} </td>
                </ng-container>
                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                        <div *ngIf="!visualizar">Ações</div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="w-100 d-flex justify-content-center">
                            <button class="icon-btn btn btn-info btn-xs text-left ml-1" (click)="exibir(element)">
                                <i class="far fas fa-print fa-sm"></i>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
        <h5 [hidden]="!semDados" class="table-no-data">
            Nenhum registro encontrado.
        </h5>
        <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons>
        </mat-paginator>
    </div>
</div>